var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.op] || "-",
          backUrl: _vm.backUrl,
          "close-now-tag": "",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "formData form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "160px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "所属应用：", prop: "applicationId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                disabled: _vm.isDisabled,
                                size: "small",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.changeApp },
                              model: {
                                value: _vm.formData.applicationId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "applicationId", $$v)
                                },
                                expression: "formData.applicationId",
                              },
                            },
                            _vm._l(_vm.appList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "提现初始人数：",
                            prop: "cashInitUserNum",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              step: 1,
                              "controls-position": "right",
                              "step-strictly": "",
                              placeholder: "请输入提现初始人数",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.cashInitUserNum,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cashInitUserNum", $$v)
                              },
                              expression: "formData.cashInitUserNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "每日提现人数上限：",
                            prop: "cashLimitDaily",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              step: 1,
                              "controls-position": "right",
                              "step-strictly": "",
                              placeholder: "请输入提现人数上限",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.cashLimitDaily,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "cashLimitDaily", $$v)
                              },
                              expression: "formData.cashLimitDaily",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("控制每日提现用户的总人数"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "微信提现自动审核：",
                            prop: "autoAuditEnabled",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "acea-row row-middle",
                              staticStyle: { height: "32px" },
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.formData.autoAuditEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "autoAuditEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "formData.autoAuditEnabled",
                                },
                              }),
                              _vm.formData.autoAuditEnabled
                                ? _c(
                                    "div",
                                    { staticClass: "ml10 acea-row row-middle" },
                                    [
                                      _c("span", [
                                        _vm._v("提现金额小于或等于"),
                                      ]),
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          step: 0.01,
                                          "controls-position": "right",
                                          "step-strictly": "",
                                          placeholder: "请输入金额",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.formData.autoAuditPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "autoAuditPrice",
                                              $$v
                                            )
                                          },
                                          expression: "formData.autoAuditPrice",
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v("元时，自动审核通过"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "该开关为控制微信提现，是否开启自动审核提现"
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "支付宝提现自动审核：",
                            prop: "alipayAutoAuditEnabled",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "acea-row row-middle",
                              staticStyle: { height: "32px" },
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.formData.alipayAutoAuditEnabled,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "alipayAutoAuditEnabled",
                                      $$v
                                    )
                                  },
                                  expression: "formData.alipayAutoAuditEnabled",
                                },
                              }),
                              _vm.formData.alipayAutoAuditEnabled
                                ? _c(
                                    "div",
                                    { staticClass: "ml10 acea-row row-middle" },
                                    [
                                      _c("span", [
                                        _vm._v("提现金额小于或等于"),
                                      ]),
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          step: 0.01,
                                          "controls-position": "right",
                                          "step-strictly": "",
                                          placeholder: "请输入金额",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value:
                                            _vm.formData.alipayAutoAuditPrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "alipayAutoAuditPrice",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.alipayAutoAuditPrice",
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v("元时，自动审核通过"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "该开关为控制支付宝提现，是否开启自动审核提现"
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客服：", prop: "popupId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                placeholder: "请选择客服",
                                filterable: "",
                                clearable: "",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formData.popupId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "popupId", $$v)
                                },
                                expression: "formData.popupId",
                              },
                            },
                            _vm._l(_vm.qrcodeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.pageName, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "客服按钮文案：", prop: "popupDes" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "4",
                              "show-word-limit": "",
                              placeholder: "请输入客服按钮文案",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.popupDes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "popupDes",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.popupDes",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "提现说明：", prop: "cashDes" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "500px" } },
                            [
                              !_vm.isDisabled
                                ? _c("Tinymce", {
                                    model: {
                                      value: _vm.formData.cashDes,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "cashDes", $$v)
                                      },
                                      expression: "formData.cashDes",
                                    },
                                  })
                                : _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.formData.cashDes),
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:system:user:withdraw:config:save",
                            "platform:system:user:withdraw:config:update",
                          ],
                          expression:
                            "['platform:system:user:withdraw:config:save', 'platform:system:user:withdraw:config:update']",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }